// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"select-arrow_wrapper__0x55q","arrow":"select-arrow_arrow__mz8pb","active":"select-arrow_active__cmmxm"};